import React, { useRef } from 'react';
import { murmurhash } from '../../../lib/js/hash';

// Components
import Form from '../../molecules/Form';
import YesNoFormTemplate, { YesNoFormTemplateProps } from './YesNoFormTemplate';
import IForm from '../../../types/IForm';
import { LinkingPageType } from '../../../types/api/LinkingPageType';

type YesNoFormProps = Omit<YesNoFormTemplateProps, 'headlineId'> & {
  form: IForm;
  id: string;
  refreshBlock?: () => void;
  validateResponseStatus?: (...args: any[]) => boolean;
  hint?: string;
  linkingPages?: LinkingPageType;
};

export default function YesNoForm({
  form,
  hint,
  headline,
  cancelAction,
  validateResponseStatus,
  refreshBlock,
  parentPageUrl,
  transNamespaceAndKey,
  widgetId,
  errorStatuses = [],
  id,
  linkingPages,
}: YesNoFormProps) {
  const headlineId = useRef(murmurhash(form.url));

  return (
    <Form
      id={id}
      model={form}
      ariaLabelledby={headlineId.current}
      onSuccess={() => {
        if (refreshBlock) {
          setTimeout(refreshBlock, 2000);
        }
      }}
      validateResponseStatus={validateResponseStatus}
      allowNavigationOnUnsavedChanges
    >
      <YesNoFormTemplate
        cancelAction={cancelAction}
        hint={hint}
        headline={headline}
        headlineId={headlineId.current}
        transNamespaceAndKey={transNamespaceAndKey}
        parentPageUrl={parentPageUrl}
        widgetId={widgetId}
        errorStatuses={errorStatuses}
        linkingPages={linkingPages}
      />
    </Form>
  );
}
